import React from "react";
import styled from "styled-components";

const SeverityHeader = ({
  children,
  severity = "medium",
  className,
  ...props
}) => {
  return (
    <StyledSeverityHeader
      severity={severity}
      className={className}
      {...props}
    >
      {children}
    </StyledSeverityHeader>
  );
};

const getSeverityHeaderStyles = (severity) => {
  switch (severity) {
    case "high":
      return {
        color: "#e51b1d",
        backgroundColor: "#fff2f2"
      };
    case "medium":
      return {
        color: "#fda005",
        backgroundColor: "#ffeecc"
      };
    case "low":
      return {
        color: "darkgrey",
        backgroundColor: "#e6e5e3"
      };
    default:
      return {
        color: "#2e7d32",
        backgroundColor: "#eeffed"
      };
  }
};

const StyledSeverityHeader = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  margin: 8px 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  ${({ severity }) => {
    const styles = getSeverityHeaderStyles(severity);
    return `
      color: ${styles.color};
      background-color: ${styles.backgroundColor};
    `;
  }}

  &:hover {
    transform: translateY(-1px);
    box-shadow:
      rgba(0, 0, 0, 0.1) 0px 2px 8px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 2px 0px;
  }
`;

export default SeverityHeader;
